import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9d6487f4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9d6487f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6487f4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PzImage: require('/drone/src/components/PzImage/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default})
